import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './modules/auth';
import navigation from './modules/navigation';
import websocket from './modules/websocket';


export default createStore({
  modules: {
    auth,
    websocket,
    navigation,
  },
  state: {
    phone: null,
    token: null,
    patientName: '',
    patientId: '',
    topicId:'',
    dOB:'',
    dOC:'',
    dOS:'',
  },
  mutations: {
    setPhone(state, phone) {
      state.phone = phone;
    },
    setToken(state, token) {
      state.token = token;
    },
    setPatientName(state, name) {
      state.patientName = name;
    },
    setPatientId(state, id) {
      state.patientId = id;
    },
    setTopicId(state, name) {
      state.topicId = name;
    },
    setDOB(state, dOB) {
      state.dOB = dOB;
    },
    setDOC(state ,dOC) {
      state.dOC = dOC;
    },
    setDOS(state ,dOS) {
      state.dOS = dOS;
    }
  },

  getters: {
    phone: state => state.phone,
    token: state => state.token,
  },
  plugins: [createPersistedState()],
});
